require.register("app/billing/invoice/SendModal", function(exports, require, module){
  $0
  
});

